module.exports = __webpack_public_path__ + "img/notifications-with-alert.a5f4ce99.svg";